import React, { FC } from 'react';
import { observer } from 'mobx-react';
import { ConfirmationFrame } from 'webPosApp/containers';

export const ConfirmationPage: FC = observer(() => {   
    return (
        <>
            <ConfirmationFrame />
        </>
    );
});
